import React from "react";
import { TakePaymentHeaderTemplate } from "themes/application/payment/components";

function TakePaymentHeader(props) {
    return <TakePaymentHeaderTemplate {...props} />;
}

export default TakePaymentHeader;
